import Config from "@skin_config";
import { changeSecondScreen } from "@common/helpers/secondScreen";

class GoldenRaceHandler {
  _hardwareId = null;

  getStreamURL(playlistId) {
    const sportAlias = Config.thirdParty.goldenRaceStreamTempSportsMap[playlistId];

    if (!sportAlias) return ""

    return sportAlias ? `${Config.thirdParty.goldenRaceStreamURL}/${this._hardwareId}/${sportAlias}` : "";
  }

  openStream(sportName) {
    const streamURL = this.getStreamURL(sportName);

    if (streamURL) {
      changeSecondScreen(Config, { command: "ThirdParty", id: 111, url: streamURL, providerId: 21 });
    }
  }

  onIframeMessage({ data }) {
    if (data?.hardwareId) this._hardwareId = data.hardwareId;
    this._hardwareId && this.openStream(data.id);
  }
}

export default GoldenRaceHandler;
